@if (isLoading) {
  <div class="min-h-96 flex items-center justify-center">
    <l-spinner/>
  </div>
} @else {
  <section class="relative flex flex-col h-full items-center justify-center gap-5 bg-lGray900 rounded-2xl">
    @if (isCourseComplete) {
      <img class="absolute top-0 left-0 w-full h-[70%] z-0 lg:h-auto lg:-translate-y-14" src="assets/svg/certificate-border.svg" alt="Borda decorativa do certificado">

      <div class="flex flex-col h-full items-center justify-center gap-5 z-10 mt-20">
        <img src="assets/icons/medal.svg" alt="Medalha" class="w-60 h-60">

        <div class="flex flex-col items-center gap-2">
          <h2 class="text-xl font-bold text-lWhite">Curso concluído com sucesso!</h2>
          <p class="text-lSecondary">Cada conquista te aproxima da sua melhor versão.</p>
        </div>
        
        <button lButton [bType]="buttonTypeEnum.PRIMARY" [bRadius]="buttonRadiusEnum.CIRCLE" (click)="downloadCertificate()" class="!w-60">
          Download certificado
        </button>

        <button lButton [bType]="buttonTypeEnum.OUTLINE" [bRadius]="buttonRadiusEnum.CIRCLE" (click)="restartModule()" class="!w-60">
          Refazer módulo
        </button>
      </div>
      
    } @else {
      <span class="absolute top-0 left-0 w-full h-8 bg-gradient-brand"></span>
      <div class="flex flex-col gap-2 items-center">
        <h2 class="text-6xl font-bold text-lWhite">{{ scoreText }}</h2>
        <p class="text-lWhite text-xl font-medium">{{ resultText }}</p>
      </div>
      
      @if (isLastModule) {
        <button
          lButton
          [bType]="buttonTypeEnum.PRIMARY"
          [bRadius]="buttonRadiusEnum.CIRCLE"
          [disabled]="isLoading"
          (click)="hasPassed ? finishCourse() : restartModule()"
          class="!w-60"
        >
          {{ hasPassed ? 'Concluir curso' : 'Refazer módulo' }}
        </button>
      } @else {
        <button lButton [bType]="buttonTypeEnum.PRIMARY" [bRadius]="buttonRadiusEnum.CIRCLE" (click)="hasPassed ? goToNextModule() : restartModule()" class="!w-60">
          {{ hasPassed ? 'Próximo módulo' : 'Refazer módulo' }}
        </button>
      }
      
    }
    
  </section>
}
